export default {
  type: 'Pet',
  sections: [
    { id: 'pet1', title: 'Pet Insurance Introduction' },
    { id: 'htgbr', title: 'How to Get The Best Rate' },
    { id: 'coverage', title: 'Components and Coverage' },
    { id: 'pet2', title: 'Main Price Impacting Factors' }
  ],
  introData: {
    title: 'Pet Insurance Guide',
    paragraphs: [
      "Welcome to Insurance Express's pet insurance guide! We're dedicated to helping pet owners protect their furry family members by offering the best coverage at affordable rates. With years of experience in the industry, we have the knowledge and expertise to help you understand the ins and outs of pet insurance.",
      "As a leading provider of pet insurance in our region, we have access to a variety of insurance markets, allowing us to offer a wide range of coverage options to our clients. In this guide, we'll explain what pet insurance is, the different types of policies available, and provide tips on how to get the best rate on your policy.",
      "Whether you're a first-time pet owner or looking to switch your existing policy, we hope that this guide will provide you with the information you need to make an informed decision. So, let's get started!"
    ]
  },
  bestRateTips: [
    "Shop around: Compare rates from multiple pet insurance providers to ensure you're getting the best value for your money.",
    "Insure your pet early: The younger your pet is when you enroll, the lower your premium will typically be.",
    "Choose a higher deductible: Opting for a higher deductible can lower your monthly premiums.",
    "Bundle policies: Some insurance companies offer discounts when you bundle pet insurance with other policies like home or auto.",
    "Look for breed-specific discounts: Some companies offer special rates for certain breeds that are known to have fewer health issues."
  ],
  briefGuide: "Pet insurance helps cover the cost of veterinary care if your pet becomes ill or injured. As veterinary medicine continues to advance, the cost of care can be significant. Pet insurance provides peace of mind, ensuring you won't have to choose between your pet's health and your finances.",
  coverageItems: [
    "What is pet insurance and why is it important",
    "Types of pet insurance coverage: accident-only, accident and illness, wellness",
    "Understanding deductibles, reimbursement levels, and annual limits",
    "What's typically covered by pet insurance",
    "Common exclusions and limitations",
    "How to choose the right coverage for your pet's needs"
  ],
  additionalInfo: {
    overview: "Pet insurance helps protect you financially in case your pet needs veterinary care due to illness or injury. Understanding the different types of coverage available can help you choose the best policy for your pet's needs.",
    sections: [
      {
        title: "Types of pet insurance coverage",
        paragraphs: [
          "Accident-only coverage: This covers injuries resulting from accidents, but not illnesses.",
          "Accident and illness coverage: This more comprehensive option covers both injuries and illnesses.",
          "Wellness coverage: Often offered as an add-on, this covers routine care like vaccinations and annual check-ups."
        ]
      },
      {
        title: "Understanding your policy terms",
        paragraphs: [
          "Deductible: The amount you pay out of pocket before your insurance kicks in.",
          "Reimbursement level: The percentage of the bill the insurer will pay after your deductible.",
          "Annual limit: The maximum amount your policy will pay out each year."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Pet Insurance",
    description: "When comparing rates and coverages for pet insurance, it is important to keep in mind these key factors that insurance companies consider when determining your premium.",
    factors: [
      {
        title: "Pet's Age",
        description: "The age of your pet significantly impacts insurance costs. The younger your pet is when you enroll, the lower your premium will be. Most companies have upper age limits for new policies.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Breed",
        description: "Some breeds are predisposed to certain health conditions, which can affect your premium. Purebred animals often have higher rates than mixed breeds due to their higher risk of hereditary conditions.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Coverage Level",
        description: "The type of coverage you choose (accident-only, accident and illness, or wellness coverage), as well as your deductible, reimbursement level, and annual limit, all impact your premium.",
        imageUrl: "/images/productPageImages/credit.png"
      },
      {
        title: "Location",
        description: "Where you live affects your pet insurance rates. Veterinary costs vary by region, so pet owners in areas with higher veterinary costs typically pay more for pet insurance.",
        imageUrl: "/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Home Insurance",
      imageUrl: "@/assets/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Auto Insurance",
      imageUrl: "@/assets/images/product-type-icons/autoInsurance.svg",
      link: "/products/autoinsurance"
    },
    {
      title: "Life Insurance",
      imageUrl: "@/assets/images/product-type-icons/lifeInsurance.svg",
      link: "/products/lifeinsurance"
    }
  ],
  ctaText: "(Home, Auto, Life, etc.)"
}; 